import { Http } from '@/lib/http';

export class AuthService extends Http {
  constructor() {
    super();
  }

  signIn(email, password) {
    return this.httpClient().post(`/auth/log-in`, {
      email,
      password
    });
  }

  signInWith2fa(data) {
    if (!data.useBackupCode) {
      return this.httpClient().post(`/auth/2fa/log-in`, data);
    } else {
      return this.httpClient().post(`/auth/2fa/log-in-backup-code`, data);
    }
  }

  signOut(id) {
    if(!id) return null;

    return this.httpClient().post(`/auth/log-out/${id}`);
  }

  getPrivileges(userId) {
    return this.httpClient().get(`${this.endpoint}/${userId}/privileges`);
  }

  changePassword(id, oldPassword, newPassword) {
    return this.httpClient().put(`users/${id}/password`, {
      oldPassword: oldPassword,
      newPassword: newPassword
    });
  }

  requestPasswordChange(email) {
    return this.httpClient().patch(
      `settings/system-settings/users/password-reset`,
      { email }
    );
  }

  verifyForgottenPassword(token) {
    return this.httpClient().post(
      `users/forget/password/verification/${token}`
    );
  }

  getMe() {
    return this.httpClient().get(`/auth/me`);
  }
}
